import React from "react";
import {
    Button,
    Card,
    CardHeader,
    CardBody,
    CardTitle,
    Row,
    Col,
    Table,
    Input,
    UncontrolledTooltip,
    FormGroup,
    Label
} from "reactstrap";

// Requests
import { getBrokersRequest, deleteBrokerRequest} from "api/broker";
// Helpers
import { hasPermission } from "helpers/auth";
// Components
import ConfirmationModal from "../../components/ConfirmationModal/ConfirmationModal";

class Brokers extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
        brokers: null,
          alert: null,
          total: 0,
          pages: 0,
          current_page: 0,
          start_page: 0,
          end_page: 9,
          first_page: 0,
          last_page: 0,
          deleteBrokerId: '',
          filters: { limit: 25 }, 
          loading: true
        }
        this.timeout = null;
    }

    async componentDidMount() {
        await this.getBrokers()
    }

    getBrokers = async () => {   
        this.setState({loading: true})
        const { filters } = this.state;
        const brokersObj = await getBrokersRequest(filters);
        const brokers = brokersObj.brokers;
        const total = brokersObj.total;
        const pages = Math.ceil(total / filters.limit);
        const last_page = pages - 1;
        const end_page = pages > 10 ? 9 : pages - 1;

        this.setState({
            brokers,
            total,
            pages,
            last_page,
            end_page,
            loading: false
        })
    }

    onChangeSearch = (event) => {
        const { filters } = this.state;	
		this.setState({
            filters: {
                ...filters,
                search: event.target.value,
                page: 0,
            }
		})
		if (this.timeout) {
			clearTimeout(this.timeout);
		}
		this.timeout = setTimeout(() => {
			this.getBrokers();
		}, 300);
    }

    goTo = (path) => this.props.history.push(path);

    openConfirmation = (id) => () => {
		this.setState({
			deleteBrokerId: id
		});
		this.deleteConfirmationModal.toggle();
    }
    
    deleteBroker = async () => {
		const { deleteBrokerId } = this.state;
        await deleteBrokerRequest(deleteBrokerId);
        this.getBrokers()
	}

    render() {

        const {
            brokers,
            filters,
            loading
        } = this.state;

        const {
            search
        } = filters;

        return (
            <>
                <div className="content">
                <Row>
                    <Col md="12">
                    <Card>
                        <CardHeader>
                            <CardTitle className="d-inline-block" tag="h4">
                                Brokers
                            </CardTitle>
                            <FormGroup>
                                <Label>Broker</Label>
                                <Input placeholder="Search brokers..." value={search} type="text" onChange={this.onChangeSearch}></Input>
                            </FormGroup>
                            {hasPermission('CreateBroker') ? <Button className="pull-right mb-3 add-btn" color="primary" onClick={() => this.goTo('/broker/create')}><i className="tim-icons icon-simple-add" /> Broker</Button> : null}
                        </CardHeader>
                        <CardBody>
                        <Table responsive>
                            <thead className="text-primary">
                            <tr>
                                <th>Name</th>
                                <th>Email</th>
                                <th>Phone</th>
                                <th className="text-right">Actions</th>
                            </tr>
                            </thead>
                            <tbody>
                                { loading ? 
                                <tr>
                                    <td colSpan="12">Loading...</td>
                                </tr>
                                :
                                brokers && brokers.length > 0 ? 
                                    brokers.map((broker) => {
                                        return (
                                            <tr key={broker._id}>
                                                <td>{broker.name}</td>
                                                <td>{broker.email || "N/A"}</td>
                                                <td>{broker.phone || "N/A"}</td>
                                                <td className="text-right">
                                                    <Button
                                                        className="btn-link btn-icon"
                                                        color="success"
                                                        id={`tooltip-view-${broker._id}`}
                                                        size="sm"
                                                        onClick={() => this.goTo(`/broker?id=${broker._id}`)}
                                                    >
                                                        <i className="tim-icons icon-zoom-split" />
                                                    </Button>
                                                    <UncontrolledTooltip
                                                        delay={0}
                                                        target={`tooltip-view-${broker._id}`}
                                                    >
                                                        View
                                                    </UncontrolledTooltip>
                                                    {hasPermission('EditBroker') ? <>
                                                        <Button
                                                            className="btn-link btn-icon"
                                                            color="info"
                                                            id={`tooltip-edit-${broker._id}`}
                                                            size="sm"
                                                            onClick={() => this.goTo(`/broker/edit?id=${broker._id}`)}
                                                        >
                                                            <i className="tim-icons icon-pencil" />
                                                        </Button>
                                                        <UncontrolledTooltip
                                                            delay={0}
                                                            target={`tooltip-edit-${broker._id}`}
                                                        >
                                                            Edit
                                                        </UncontrolledTooltip>
                                                        <Button
                                                            className="btn-link btn-icon"
                                                            color="danger"
                                                            id={`tooltip-delete-${broker._id}`}
                                                            size="sm"
                                                            onClick={this.openConfirmation(broker._id)}
                                                        >
                                                            <i className="tim-icons icon-simple-remove" />
                                                        </Button>
                                                        <UncontrolledTooltip
                                                            delay={0}
                                                            target={`tooltip-delete-${broker._id}`}
                                                        >
                                                            Delete
                                                        </UncontrolledTooltip>
                                                    </> : null}
                                                </td>
                                            </tr>
                                        )
                                    })
                                : 
                                <tr>
                                    <td colSpan="6">There's no Broker to show</td>
                                </tr>
                                }
                            </tbody>
                        </Table>
                        </CardBody>
                    </Card>
                    </Col>
                </Row>
                <ConfirmationModal
                    ref={el => this.deleteConfirmationModal = el}
                    title="Delete Broker?"
                    buttons={[
                        { title: 'Cancel', className: 'btn-primary-override btn btn-primary' },
                        { title: 'Delete', className: 'btn-danger-override btn btn-danger', onClick: this.deleteBroker }
                    ]}
                >
                    Are you sure you want to delete this broker?
                </ConfirmationModal>
                </div>
            </>
        )
    }
}

export default Brokers;